import { atom } from 'recoil'

export const OverlayPreviousDetections = atom<boolean>({ key: 'overlay-previous-detections', default: false })
